export const trackersGoogleTagManager = {
  loaded: false,
  enabled: false,

  // Load Google Tag Manager and begin tracking.
  // Note, if your juristiction requires prior consent before tracking technologies are used,
  // then you should have obtained consent BEFORE you call this method!
  load: function(gtmId) {
    if (!this.loaded) {
      console.log("Loading scripts and enabling Google Tag Manager");

      // See https://developers.google.com/tag-manager/quickstart
      (function (w, d, s, l, i) {
        w[l] = w[l] || []; w[l].push({
          'gtm.start':
      new Date().getTime(),
          event: 'gtm.js',
        }); const f = d.getElementsByTagName(s)[0];
        const j = d.createElement(s); const dl = l != 'dataLayer' ? `&l=${l}` : ''; j.async = true; j.src = `//www.googletagmanager.com/gtm.js?id=${i}${dl}`; f.parentNode.insertBefore(j, f);
      }(window, document, 'script', 'dataLayer', gtmId));

      this.loaded = true;
      this.enabled = true;
    } else {
      console.log("Google Tag Manager scripts already loaded - re-enabling");
      // No specific way to disable or re-enable GTM once it's been loaded
      this.enabled = true;
    }
  },

  // Revoke consent for this user to be tracked by Google Analytics
  revokeConsent: function() {
    console.log("Disabling Google Tag Manager");
    // No specific way to disable GTM once it's been loaded - just don't load it on the next page
    this.enabled = false;
  }
};
